import { Injectable } from "@angular/core";
import { RelationshipTypeLabels } from "@models/relationships/relationship-type.enum";
import {
  AgOfficeholderNameComponent
} from "@pages/companies/components/company-profile-page/components/company-officeholders/components/ag-officeholder-name/ag-officeholder-name.component";
import { OfficeholderGroupModel } from "@pages/companies/models/officeholder-group-model";
import { AgAddressesComponent } from "@shared/components/grid/ag-cells/common/ag-addresses/ag-addresses.component";
import { AgDateCellComponent } from "@shared/components/grid/ag-cells/common/ag-date-cell/ag-date-cell.component";
import {
  AgMultipleRowsComponent
} from "@shared/components/grid/ag-cells/common/ag-multiple-rows/ag-multiple-rows.component";
import { CountryPipe } from "@shared/pipes/countryPipe";
import { DinPipe } from "@shared/pipes/din.pipe";
import { BaseGridService } from "@shared/services/base/base-grid.service";
import { getCommonActionCellColDef } from "@shared/utils/grid/get-common-column-chooser-params";
import { CellClickedEvent, ColDef, ValueFormatterParams, ValueGetterParams } from "ag-grid-community";

@Injectable()
export class CompanyOfficeholdersGridService extends BaseGridService {
  setColDefsWithOpenOfficerAction(actionColumn: ColDef, openOfficeholdersProfile: Function) {
    const colDefs: ColDef[] = [
      {
        headerName: 'Officeholder',
        field: 'officeholderName',
        width: 200,
        flex: 1.7,
        cellRenderer: AgOfficeholderNameComponent,
        cellRendererParams: { pendingButtonState: true },
        editable: false,
        cellClass: 'cursor-pointer h-100 d-flex align-items-center',
        onCellClicked: (event: CellClickedEvent<OfficeholderGroupModel>) => openOfficeholdersProfile(event.data!)
      },
      {
        headerName: 'Positions',
        field: 'types',
        autoHeight: true,
        width: 60,
        flex: 1,
        valueGetter: (params: ValueGetterParams<OfficeholderGroupModel>) => {
          const types = params.data?.types ?? [];
          const lastTypeIndex = types.length - 1;
          return types.map((type, index) => RelationshipTypeLabels[type] + (index != lastTypeIndex ? ', ' : ''));
        },
        cellRenderer: AgMultipleRowsComponent,
        cellRendererParams: {
          rowClass: 'line-height-16 h-auto',
          wrapperClass: 'd-inline-block align-middle'
        }
      },
      {
        headerName: 'Address',
        field: 'address.normalizedFullAddress',
        width: 500,
        flex: 4,
        valueGetter: (params: ValueGetterParams<OfficeholderGroupModel>) => [params.data?.address],
        cellRenderer: AgAddressesComponent,
        cellClass: 'h-100 d-flex align-items-center'
      },
      {
        headerName: 'Appointment Date',
        field: 'appointmentDate',
        width: 150,
        flex: 1,
        cellRenderer: AgDateCellComponent,
      },
      {
        headerName: 'Cessation Date',
        field: 'cessationDate',
        width: 150,
        flex: 1,
        cellRenderer: AgDateCellComponent,
      },
      {
        headerName: 'Date of Birth',
        field: 'dob',
        width: 150,
        flex: 1,
        hide: true,
        cellRenderer: AgDateCellComponent,
      },
      {
        headerName: 'Place of Birth',
        field: 'birthCity',
        width: 150,
        flex: 1,
        hide: true,
        valueFormatter: (params: ValueFormatterParams<OfficeholderGroupModel>) => CountryPipe.formatPlaceOfBirth(params.data?.birthCity, params.data?.birthCountry, '-')
      },
      {
        headerName: 'Director ID',
        field: 'individual.din',
        width: 150,
        flex: 1,
        hide: true,
        valueFormatter: (params: ValueFormatterParams<OfficeholderGroupModel, string | null>) => DinPipe.formatValue(params.value)
      },
    ];

    const actionColDef: ColDef = {
      ...getCommonActionCellColDef(colDefs),
      ...actionColumn
    };

    colDefs.push(actionColDef);

    this.colDefs.set(colDefs.map((colDef) => {
      colDef.suppressHeaderMenuButton = true;
      return colDef;
    }));
  }
}
